import React from 'react';
import { Pin } from 'lucide-react';
import { Post } from '../../types/post';
import { getEditedBadgeText, getPinnedBadgeText } from '../../utils/permissions';

interface PostBadgesProps {
  post: Post;
  textColor: string;
  accentColor: string;
}

export function PostBadges({ post, textColor, accentColor }: PostBadgesProps) {
  return (
    <>
      {/* Pinned Badge - Top Right */}
      {post.isPinned && (
        <div
          key="pinned-badge"
          className="absolute top-3 right-12 flex items-center gap-1 px-2 py-1 rounded text-xs font-semibold"
          style={{
            backgroundColor: accentColor + '30',
            color: textColor,
            border: `1px solid ${accentColor}`
          }}
        >
          <Pin size={12} />
          {getPinnedBadgeText(post.pinnedByType)}
        </div>
      )}

      {/* Edited Badge - Bottom Right */}
      {post.editedBy && (
        <div
          key="edited-badge"
          className="absolute bottom-3 right-3 px-2 py-1 rounded text-xs"
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            color: textColor + 'cc'
          }}
        >
          {getEditedBadgeText(post.editedByType)}
        </div>
      )}
    </>
  );
}
